export default __webpack_public_path__ + "static/media/alert_notification_icon.07a2f565.svg";